import { inject } from '@angular/core';

import { map, take } from 'rxjs';

import { AuthRestaurantService } from '@tablesready/frontend-store';
import { PricePlansRestrictionsService } from '@tablesready/frontend-restrictions';
import { FrontendPaidFeatureService } from '@tablesready/frontend-paid-feature-alert';

export const starterPlanGuard = () => {
  const authRestaurantService = inject(AuthRestaurantService);
  const pricePlansRestrictionsService = inject(PricePlansRestrictionsService);
  const paidFeatureService = inject(FrontendPaidFeatureService);

  const user = authRestaurantService.get();
  const isLocationOnStarterOrBusinessPlan = pricePlansRestrictionsService.availableForStarterPlan(user.account.subscriptionType, user.location.recurly);

  if (!isLocationOnStarterOrBusinessPlan) {
    return paidFeatureService.freePlanLocationModalDisplay(user, true)
      .pipe(
        take(1),
        map(() => false),
      );
  }

  return true;
};
